/**
 * The three timings behind "acknowledge every navigation". They live here, in
 * a leaf module, because both the router (`router.ts`) and the shell's
 * progress bar (`components/chrome.tsx`) read them, and chrome sits inside
 * the route tree the router imports — a constant exported from `router.ts`
 * would make that import a cycle.
 */

/**
 * How long a route may stay pending before the skeleton replaces the outgoing
 * screen, and how long the progress bar's live region waits before it says
 * "Loading…". Below this a navigation just completes; the bar itself has
 * already acknowledged the click on the first frame.
 */
export const PENDING_MS = 150;

/**
 * Once the skeleton is shown it stays at least this long, so a loader that
 * resolves at 160 ms does not flash a skeleton for one frame.
 */
export const PENDING_MIN_MS = 300;

/**
 * How long the pointer must rest on a link before `preload: 'intent'` fires.
 * TanStack's default is 50 ms, which turns a pointer crossing the sidebar into
 * a burst of loader fetches — each one a `POST /campaigns/overview`-sized
 * request queued on the same serial D1 connection as the click that follows.
 */
export const PRELOAD_DELAY_MS = 150;
